import numberToLocalString from "./numberToLocalString";

const getPriceText = (
  charge: number | string | undefined,
  has_alpha: boolean,
  isNotLocale: boolean,
) => {
  let results;
  if (charge && typeof charge === "number") {
    results = isNotLocale ? `${charge}만원` : `${numberToLocalString(charge)}원`;
  } else if (typeof charge === "string") {
    return charge;
  } else {
    return "무료";
  }

  return has_alpha ? `${results} + a` : results;
};

export default getPriceText;
